module.exports = __webpack_public_path__ + "static/media/Loader.fe114894.svg";